// removed by extract-text-webpack-plugin
module.exports = {"errorContainer":"errorContainer__2aQzi","errorText":"errorText__1eDvx","paymentBenefits":"paymentBenefits__3ZCCv","errorIcon":"errorIcon__DDZmg","errorMessageContainer":"errorMessageContainer__2TKzL","errorMessage":"errorMessage__2wp-R"};


//////////////////
// WEBPACK FOOTER
// ./components/errorScreen/style.css
// module id = Xvbp
// module chunks = 323 362 379 380